"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchJwttokenSN = fetchJwttokenSN;
exports.setJwttokenSN = setJwttokenSN;
exports.getUserSession = getUserSession;
exports.getUserSessionToken = getUserSessionToken;
exports.isActionTrackingToBeAcknowledged = isActionTrackingToBeAcknowledged;
exports.isActionTrackingToBeAcknowledgedError = isActionTrackingToBeAcknowledgedError;
exports.setPersonaUser = exports.getPersonaUser = exports.loadingActionTrackingItemsToBeAcknowledged = exports.setNumberOfActionTrackingItemsToBeAcknowledged = exports.setTodoStatus = exports.setEntitlementStatus = exports.updateBrands = exports.authentication = exports.findByUserAppAndFunctions = exports.findByUserAppAndFunctionsError = exports.findByUserAppAndFunctionsSuccess = exports.updateAppsError = exports.updateprofileImage = exports.updateDepartment = exports.updateApps = exports.getUserApps = exports.sideNavMenuUpdate = exports.sideNavHide = exports.sideNavShow = exports.sideNavToggle = exports.loading = exports.commonServiceError = exports.commonServiceSuccess = exports.dispatchService = exports.commonService = void 0;

var _baseLayout = require("./base-layout.constants");

var _utils = require("cornerstone_ui_core/lib/utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var commonService = function commonService(_ref, callback) {
  var service = _ref.service,
      args = _ref.args;
  return {
    type: _baseLayout.COMMON_SERVICE,
    args: args,
    service: service,
    callback: callback
  };
};

exports.commonService = commonService;
var dispatchService = (0, _utils.createDispatchService)(commonService);
exports.dispatchService = dispatchService;

var commonServiceSuccess = function commonServiceSuccess(result) {
  return _objectSpread({
    type: _baseLayout.COMMON_SERVICE_SUCCESS
  }, result);
};

exports.commonServiceSuccess = commonServiceSuccess;

var commonServiceError = function commonServiceError(error) {
  return {
    type: _baseLayout.COMMON_SERVICE_ERROR,
    error: error
  };
};

exports.commonServiceError = commonServiceError;

var loading = function loading(_loading) {
  return {
    type: _baseLayout.LOADING,
    loading: _loading
  };
};

exports.loading = loading;

var sideNavToggle = function sideNavToggle() {
  return {
    type: _baseLayout.SIDENAV_TOGGLE
  };
};

exports.sideNavToggle = sideNavToggle;

var sideNavShow = function sideNavShow() {
  return {
    type: _baseLayout.SIDENAV_SHOW
  };
};

exports.sideNavShow = sideNavShow;

var sideNavHide = function sideNavHide() {
  return {
    type: _baseLayout.SIDENAV_HIDE
  };
};

exports.sideNavHide = sideNavHide;

var sideNavMenuUpdate = function sideNavMenuUpdate(menus) {
  return {
    type: _baseLayout.SIDENAV_MENU,
    menus: menus
  };
};
/**
 * Dispatched when the user is authenticated by OKTA
 * @param  {userId} userId recieved by OKTA Login
 * @return {object} An action object with a type of GET_USERAPPS
 */


exports.sideNavMenuUpdate = sideNavMenuUpdate;

var getUserApps = function getUserApps(userId) {
  return {
    type: _baseLayout.GET_USERAPPS,
    userId: userId
  };
};

exports.getUserApps = getUserApps;

var updateApps = function updateApps(result) {
  return {
    type: _baseLayout.GET_USERAPPS_SUCCESS,
    result: result
  };
};

exports.updateApps = updateApps;

var updateDepartment = function updateDepartment(Dept) {
  return {
    type: _baseLayout.UPDATE_DEPARTMENT,
    Dept: Dept
  };
};

exports.updateDepartment = updateDepartment;

var updateprofileImage = function updateprofileImage(profileImage) {
  return {
    type: _baseLayout.UPDATE_PROFILE_IMAGE,
    profileImage: profileImage
  };
};

exports.updateprofileImage = updateprofileImage;

var updateAppsError = function updateAppsError(err) {
  return {
    type: _baseLayout.GET_USERAPPS_ERROR,
    err: err
  };
};

exports.updateAppsError = updateAppsError;

var findByUserAppAndFunctionsSuccess = function findByUserAppAndFunctionsSuccess(data) {
  return {
    type: _baseLayout.FINDBYUSERAPPANDFUNCTIONS_SUCCESS,
    data: data
  };
};

exports.findByUserAppAndFunctionsSuccess = findByUserAppAndFunctionsSuccess;

var findByUserAppAndFunctionsError = function findByUserAppAndFunctionsError(err) {
  return {
    type: _baseLayout.FINDBYUSERAPPANDFUNCTIONS_ERROR,
    err: err
  };
};

exports.findByUserAppAndFunctionsError = findByUserAppAndFunctionsError;

var findByUserAppAndFunctions = function findByUserAppAndFunctions(appName, userId) {
  return {
    type: _baseLayout.FINDBYUSERAPPANDFUNCTIONS,
    appName: appName,
    userId: userId
  };
};

exports.findByUserAppAndFunctions = findByUserAppAndFunctions;

var authentication = function authentication(_ref2) {
  var authenticated = _ref2.authenticated,
      userinfo = _ref2.userinfo;
  return {
    type: _baseLayout.AUTHENTICATION,
    authenticated: authenticated,
    userinfo: userinfo
  };
};
/**
 * Dispatched when user is authenticated by OKTA
 * @param  {brands} brands list recieved by servcie
 * @return {object} An action object with a type of UPDATE_BRANDS
 */


exports.authentication = authentication;

var updateBrands = function updateBrands(brands) {
  return {
    type: _baseLayout.UPDATE_BRANDS,
    brands: brands
  };
};
/**
 * Dispatched to set the entitlement status of the user
 * @param {*} status
 */


exports.updateBrands = updateBrands;

var setEntitlementStatus = function setEntitlementStatus(status) {
  return {
    type: _baseLayout.SET_ENTITLEMENT_STATUS,
    status: status
  };
};
/**
 * Dispatched to set the showTodo status
 * @param {*} status
 */


exports.setEntitlementStatus = setEntitlementStatus;

var setTodoStatus = function setTodoStatus(status) {
  return {
    type: _baseLayout.SET_SHOW_TODO,
    status: status
  };
};

exports.setTodoStatus = setTodoStatus;

function fetchJwttokenSN(userId, appName, decoded) {
  return {
    type: _baseLayout.FETCH_JWTTOKENSN,
    userId: userId,
    appName: appName,
    decoded: decoded
  };
}

function setJwttokenSN(data) {
  return {
    type: _baseLayout.SET_JWTTOKENSN,
    data: data
  };
}

function getUserSession(cacheKey) {
  return {
    type: _baseLayout.GET_USER_SESSION,
    cacheKey: cacheKey
  };
}

function getUserSessionToken(cacheKeyDetails) {
  return {
    type: _baseLayout.GET_USER_SESSION_TOKEN,
    cacheKeyDetails: cacheKeyDetails
  };
}

var setNumberOfActionTrackingItemsToBeAcknowledged = function setNumberOfActionTrackingItemsToBeAcknowledged(count) {
  return {
    type: _baseLayout.SET_ACTION_TRACKING_TO_BE_ACKNOWLEDGED,
    count: count
  };
};

exports.setNumberOfActionTrackingItemsToBeAcknowledged = setNumberOfActionTrackingItemsToBeAcknowledged;

var loadingActionTrackingItemsToBeAcknowledged = function loadingActionTrackingItemsToBeAcknowledged(load) {
  return {
    type: _baseLayout.LOADING_ACTION_TRACKING_TO_BE_ACKNOWLEDGED,
    load: load
  };
};

exports.loadingActionTrackingItemsToBeAcknowledged = loadingActionTrackingItemsToBeAcknowledged;

function isActionTrackingToBeAcknowledged(input) {
  return {
    type: _baseLayout.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED,
    input: input
  };
}

function isActionTrackingToBeAcknowledgedError(input) {
  return {
    type: _baseLayout.IS_ACTION_TRACKING_TO_BE_ACKNOWLEDGED_ERROR,
    input: input
  };
}

var getPersonaUser = function getPersonaUser(userId, appName) {
  return {
    type: _baseLayout.GET_PERSONA_FOR_USER,
    userId: userId,
    appName: appName
  };
};

exports.getPersonaUser = getPersonaUser;

var setPersonaUser = function setPersonaUser(personaData) {
  return {
    type: _baseLayout.SET_PERSONA_FOR_USER,
    personaData: personaData
  };
};

exports.setPersonaUser = setPersonaUser;